module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-512x512-53c2f3019ce260b8eb3d1010c63c3743.png";